import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import logo from '../../../assets/static/images/logo.png';
import { defaultImage } from '../../../itrust_common/components/HelperFunctions';
import { organisationLoad, organisationValidate } from '../../../redux/actions/public/OrganisationActions';
import { setAccountType } from '../../../itrust_common/redux/actions/authActions';
import nonExistingUrlImg from '../../../assets/static/images/non_existing_url.jpg';
import nonExistingUrlImgTab from '../../../assets/static/images/non_existing_url_tab.png';

let AccountType = ({ organisation, dispatch, isOrgNotExist }) => {

  const handleAccountType = (type) => {
    dispatch(setAccountType(type))
  }

  useEffect(() => {
    dispatch(organisationLoad())
    dispatch(organisationValidate())
  }, [])

  return (
    <div className={`bg-light h-100 ${!isOrgNotExist && 'container'}`}>
      <Helmet>
        <title>{organisation.name}</title>
        <link rel="shortcut icon" href={organisation.logo_attributes ? organisation.logo_attributes.file.url : logo} sizes="16x16" />
      </Helmet>
      {isOrgNotExist ? <picture>
        <source media="(max-width: 800px)" srcSet={nonExistingUrlImgTab} type="image/png" />
        <img src={nonExistingUrlImg} alt='Non Existing URL Image' className='w-100 h-100' />
      </picture> :
        <>
          <div className="text-center my-auto">
            {organisation.logo_attributes ? <img src={defaultImage(organisation.logo_attributes)} alt="logo" className="org-logo-login border-0 mb-9" /> : <p className="store-logo-text py-10 mx-auto"><span className="bg-white p-4">{organisation.name}</span></p>}
          </div>
          <div className="text-center">
            <h3 className="pb-7">Choose Account Type</h3>
          </div>
          <div className="d-flex justify-content-center my-9">
            <Link to={`/doctor/sign-in`} onClick={() => handleAccountType("doctor")}>
              <div className='bg-white p-5 d-flex flex-column justify-content-center align-items-center login-select mr-6 shadow'>
                <i class="las la-eye text-white rounded-circle font-size-100 bg-primary p-3"></i>
                <h3 className="pt-9">Administrator, Doctor, and Staff</h3>
              </div>
            </Link>
            <Link to={`/patient/sign-in`} onClick={() => handleAccountType("patient")}>
              <div className='bg-white p-5 d-flex flex-column justify-content-center align-items-center login-select shadow'>
                <i class="las la-user text-white rounded-circle font-size-100 bg-primary p-3"></i>
                <h3 className="pt-9">Patient</h3>
              </div>
            </Link>
          </div>
          <div className="footer mx-auto fixed-bottom text-dark pb-6 w-100 text-center">
            <span>&copy; Copyright {new Date().getFullYear()} iTrust.io LLC. All rights reserved.</span>
          </div>
        </>
      }
    </div>
  );
}

const mapStateToProps = store => {
  const { auth, publicOrganisation } = store
  return {
    accountType: auth.accountType,
    currentUser: auth.user,
    organisation: publicOrganisation.current_organisation,
    isOrgNotExist: publicOrganisation.isOrgNotExist
  };
};

export default connect(mapStateToProps)(AccountType);